import React, { useEffect, useState } from "react";
import axios from "axios";
import { variables } from "./Variables.js";

export default function FootballMatches() {
  const jsonUrl = variables.basename_url + "updates/index/Athlethixnet_HomeEn_Matches.json";
  const [isLoading, setIsLoading] = useState(true);
  const todayStr = new Date().toISOString().split('T')[0];
  const [selectedDate, setSelectedDate] = useState(''); 
  const [hasSelectedDate, setHasSelectedDate] = useState(false);
  const [leagueData, setLeagueData] = useState({});

  const getSelectedMonthYear = () => {
    if (!selectedDate) return "All Matches ";
    const date = new Date(selectedDate);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  };

  const changeDate = (offset) => {
    const current = selectedDate ? new Date(selectedDate) : new Date();
    current.setDate(current.getDate() + offset);
    setSelectedDate(current.toISOString().split('T')[0]);
    setHasSelectedDate(true);
  };

  const generateDateList = () => {
    const dates = [];
    for (let i = -3; i <= 3; i++) {
      const d = selectedDate ? new Date(selectedDate) : new Date();
      d.setDate(d.getDate() + i);
      dates.push({
        fullDate: d.toISOString().split('T')[0],
        dayName: d.toLocaleDateString('en-US', { weekday: 'short' }),
        dayNumber: d.getDate(),
      });
    }
    return dates;
  };

  const dateList = generateDateList();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(jsonUrl);
        const data = response.data;

        const footballMatches = data.filter(match => match.SGT_name === "Football");

        const dateFilteredData = hasSelectedDate
          ? footballMatches.filter(match => match.SM_game_date_time?.split('T')[0] === selectedDate)
          : footballMatches;
        /* *************************************************************** */
          //Ordering the matches from latest to old:
          //Added by Aya:
        dateFilteredData.sort((a, b) => {
          const dateA = new Date(a.SM_game_date_time);
          const dateB = new Date(b.SM_game_date_time);
          return dateB - dateA;
        });
        /* *************************************************************** */
        const organized = dateFilteredData.reduce((acc, match) => {
          const section = match.SLT_name_en;
          if (!acc[section]) acc[section] = [];
          acc[section].push(match);
          return acc;
        }, {});

        setLeagueData(organized);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedDate, hasSelectedDate, jsonUrl]);
const customStyle = (
    <style>
      {`
        .nav-btn-custom:hover {
          background-color: #dc3545 !important; 
          color: white !important;
          border-color: #dc3545 !important;
        }
        .nav-btn-custom {
          transition: all 0.3s ease; 
        }
      `}
    </style>
  );
  return (
    <div className="container custom-container">
      <div className="feature-news-content mt-3">
        <p className="TitleSectionFont p-1 bg-white">
          Welcome to AthletixNet Football Matches! Find all the latest football match schedules, live scores, and highlights.
        </p>
      </div>

     <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap">
  
  <div className="d-flex align-items-center">
    <a href="FootballMatches">
      <button type="button" className="redbackcolor text-white p-2 rounded border border-white mr-2">Football</button>
    </a>
    <a href="TennisMatches">
      <button type="button" className="grayBackground text-white p-2 rounded border border-white">Tennis</button>
    </a>
  </div>

  <div className="mx-3">
    <h3 style={{ color: '#000', fontWeight: '500', fontSize: '24px', fontFamily: 'Arial, sans-serif', margin: 0 }}>
      {getSelectedMonthYear()}
      <span style={{ fontSize: "12px", marginLeft: "8px", color: "#888" }}>
        Please select date :
      </span>
    </h3>
  </div>

  <div className="date-picker-wrapper">
    <input 
      type="date" 
      className="form-control form-control-sm" 
      value={selectedDate}
      onChange={(e) => { setSelectedDate(e.target.value); setHasSelectedDate(true); }}
      style={{ width: 'auto', cursor: 'pointer' }}
    />
  </div>

</div>

      <div className="date-scroller-container mb-4 shadow-sm bg-white rounded">
        <div className="d-flex justify-content-between align-items-center p-2">
          {customStyle}
          <button className="btn btn-light nav-btn-custom" onClick={() => changeDate(-1)}>
            <i className="fa fa-chevron-left"></i>
          </button>

          <div className="d-flex overflow-auto">
            {dateList.map((dateObj, index) => {
              const isActive = selectedDate === dateObj.fullDate;
              const isToday = todayStr === dateObj.fullDate;

              return (
                <div
                  key={index}
                  onClick={() => { setSelectedDate(dateObj.fullDate); setHasSelectedDate(true); }}
                  className={`date-item text-center mx-2 p-2 ${isActive ? 'active-date' : ''}`}
                  style={{ cursor: 'pointer', minWidth: '60px', borderBottom: isActive ? '3px solid #dc3545' : 'none' }}
                >
                  <div className="small-text text-uppercase" style={{ fontSize: '12px', color: isActive ? '#dc3545' : '#888' }}>
                    {isToday ? "Today" : dateObj.dayName}
                  </div>
                  <div className="font-weight-bold" style={{ fontSize: '18px', color: isActive ? '#dc3545' : '#333' }}>
                    {dateObj.dayNumber}
                  </div>
                </div>
              );
            })}
          </div>

          <button className="btn btn-light nav-btn-custom" onClick={() => changeDate(1)}>
            <i className="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>

      {isLoading ? (
          <p>Loading...</p>
        ) : Object.keys(leagueData).length === 0 ? (
          <div className="text-center p-4">
            <h5>No matches are scheduled for the selected day. Please check another date.</h5>
          </div>
        ) : (
          Object.keys(leagueData).map((section, index) => (
            <div className="mb-3" key={section}>
              <p hidden>{index++}</p>
              <div
                className="col-xl-12 col-lg-12 col-md-12 col-sm-12 float-left HeaderTable-margin box-title mt-1"
                style={{ backgroundColor: index % 2 === 0 ? "white" : "#eceef2" }}
              >
                <p hidden>{index++}</p>
                <div className="d-flex">
                  <div>
                    <img
                      className="Match-logo"
                      src={`${variables.MatchesImagePath}${leagueData[section][0].SLT_Logo}`}
                      width={35}
                      height={35}
                      alt={section}
                    />
                  </div>
                  <div className="logoSize ml-3">
                    <a href={"AllResultMatcehs?SLT_id=" + leagueData[section][0].SLT_id} target="_blank" className="text-decoration-none">{section}</a>
                  </div>
                </div>
              </div>
              {leagueData[section].map((match, idx) => (
                <div
                  key={idx}
                  className="container col-xl-12 col-lg-12 col-md-11 col-sm-11 BodyTable-margin pt-2 d-flex"
                  style={{ backgroundColor: index % 2 === 0 ? "white" : "#eceef2" }}
                >
                  <p hidden>{index++}</p>
                  <div className="col-md-3 border-0 rounded ml-3">
                    <h6 className="text-center BlueMacthColor">
                      {match.SM_game_date_time
                        ? match.SM_game_date_time.split('T')[0] + ' ' + match.SM_game_date_time.split('T')[1].slice(0, 5)
                        : ''}
                    </h6>
                  </div>
                  <div className="col-md-3 BlueMacthColor border-0 rounded text-right">
                    <h6 className="BlueMacthColor">
                      {match.Team1}
                      <img
                        className="ml-3"
                        src={`${variables.MatchesImg}${match.ST_logo}`}
                        width={32}
                        height={32}
                        alt={match.Team1}
                      />
                    </h6>
                  </div>
                  <div className="col-md-2 border-0 rounded">
                    <div className="h6 text-center BlueMacthColor "style={{marginBottom : 0}}>
                      {match.SM_score1 === '' || match.SM_score1 === '-1' || match.SM_score1 === '-'  ? ' ' : match.SM_score1}<span className="pl-1 pr-1">-</span>{match.SM_score2 === '' || match.SM_score2 === '-1' || match.SM_score1 === '-'  ? ' ' : match.SM_score2}
                    </div>
                    {match.IsPenalties && (
                      <div className="text-center mt-1 BlueMacthColor">
                        <span
                          style={{
                            display: 'inline-block',
                            fontSize: '14px',
                            fontWeight: 500,
                            
                          }}
                        >
                          ( {match.PenaltyScore1 === '' || match.PenaltyScore1 === '-1' || match.PenaltyScore1 == null ? '-' : match.PenaltyScore1}
                          {<span className="pl-1 pr-1">-</span>}
                          {match.PenaltyScore2 === '' || match.PenaltyScore2 === '-1' || match.PenaltyScore2 == null ? '-' : match.PenaltyScore2})
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="col-md-4 BlueMacthColor border-0 rounded text-left">
                    <h6 className="BlueMacthColor">
                      <img
                        className="mr-3"
                        src={`${variables.MatchesImg}${match.ST_logo1}`}
                        width={32}
                        height={32}
                        alt={match.Team2}
                      />
                      {match.Team2}
                    </h6>
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
  );
}